import React, { useEffect } from 'react'
// import { motion } from "motion/react";
import { motion } from "framer-motion";
import { ImageBuffer } from '../..'
import { img2, img3, img4, img5 } from '../../../assets'
import { ArrowForwardRounded, CallRounded } from '@mui/icons-material';

import './hero.css'

const Hero = () => {
    
  return (
    <>
        <section id="hero" className="hero-wrapper">
            <main className="hero-container">
                <div className="hero-container-left">
                    <button className="hero-btn-cover" type="button">
                        <span>WELLNESS WITH SERENITY</span>
                        <span className="hero-svg-arrow">
                            <ArrowForwardRounded />
                        </span>
                    </button>
                    <div className=''>
                        <motion.h1 
                            initial={{opacity: 0, y: 40}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.6, delay: 0.8}}
                            viewport={{once: true}}
                            className="hero-title-text">
                            Gloria's Serenity
                            <span className="hero-sub-text">
                                Home Health
                            </span>
                        </motion.h1>
                        <motion.p 
                            initial={{opacity: 0, y: 30}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.5, delay: 1}}
                            viewport={{once: true}}
                            className='hero-title-description'>We are committed to providing warm and professional care to our IDD friends and fellows!
                        </motion.p>
                    </div>
                    <a href="tel:+14693262931" className="hero-call-to-action-link">
                        <CallRounded className="hero-call-to-action-btn" />
                        Call Today: 
                        <span className='hero-call-to-action-link-title'> +1-469-326-2931</span>
                    </a>
                </div>
                <motion.div 
                    initial={{opacity: 0, scale: 0.9}} 
                    whileInView={{opacity: 1, scale: 1}} 
                    transition={{duration: 0.6, delay: 2}}
                    viewport={{once: true}}
                    aria-label="Photos of leaders" 
                    className="hero-container-right"
                >
                    <ImageBuffer src={img2} alt='' className="hero-image-right" />
                    <ImageBuffer src={img3} alt='' className="hero-image-right" />
                    <ImageBuffer src={img4} alt='' className="hero-image-right" />
                    <ImageBuffer src={img5} alt='' className="hero-image-right" />
                </motion.div>
            </main>
        </section>
    </>
  )
}

export default Hero